import React from 'react'
import ReuseableButton from '../../components/Button/ReusableButton'

const PPT = () => {
    const slides = {
  "Introduction": "This presentation provides a summary of the recent projects completed by our organization.",
  "Project Overview": "We completed five major projects across healthcare, infrastructure, and technology domains.",
  "Key Challenges": "Some challenges included tight deadlines, resource constraints, and integration complexities.",
  "Solutions": "Agile methodology, cross-functional teams, and strategic partnerships helped overcome obstacles.",
  "Conclusion": "All projects were delivered on time, within budget, and exceeded client expectations."
};

    const downloadPPT = async (slides:any) => {
  const response = await fetch("http://localhost:8000/api/generate-ppt", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ slides })
  });

  if (response.ok) {
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "SummaryPresentation.pptx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } else {
    console.error("Failed to download PPTX");
  }
};

  return (
    <div>
        <ReuseableButton title='Genarate Button' type='button' onClick={()=>downloadPPT(slides)}/>
    </div>
  )
}

export default PPT